<template>
	<div class="view feedback-view">
		<HeaderBar>
			<van-button size="mini" @click="onSubmitClick" type="primary">提交</van-button>
		</HeaderBar>
		<div class="title text--title">标签</div>
		<div class="tag-wrap">
			<TagItem v-for="item in tagList"
					 :key="item.id"
					 v-bind="item"
					 :click="
          () => {
            onTagClick(item.id);
          }
        "
					 :isPrimary="item.id === selectedTag" />
		</div>
		<div class="title text--title">改进建议</div>
		<div class="feedback-wrap">
			<van-field v-model="feedback"
					   placeholder="期待您的宝贵意见"
					   autosize
					   type="textarea"></van-field>
			<div class="img-wrap">
				<span class="img-item"
					  v-for="(item, index) in img_fullPath"
					  :key="index">
					<img class="upload-img"
						 :src="item" />
					<span class="remove-icon"
						  @click="onRemoveClick(index)">✖</span>
				</span>
			</div>
			<!--      <van-uploader :after-read="onImgRead">-->
			<div @click="uploadImg"
				 class="van-uploader">
				<img class="van-uploader__upload"
					 src="../../assets/images/upload.png"
					 alt="上传" />
			</div>
			<!--      </van-uploader>-->
		</div>
		<div class="title text--title">联系方式</div>
		<div class="feedback-wrap">
			<van-field v-model="contact"
					   placeholder="留下联系方式可以更方便联系您"></van-field>
		</div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui'

import { Button, Field, Uploader } from 'vant';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import { replaceEmoji } from '../../utils/regexUtil'
import { getUser } from '../../utils/storageUtil';
import TagItem from '../../components/TagItem';
import HeaderBar from '../../components/HeaderBar';

export default {
	name: 'feedback',
	components: {
		'van-button': Button,
		'van-field': Field,
		'van-uploader': Uploader,
		TagItem,
		HeaderBar
	},
	data() {
		return {
			tagList: [],
			img_path: [],
			img_fullPath: [],
			feedback: '',
			contact: '',
			selectedTag: 0
		};
	},
	created() {
		this.init();
	},
	mounted() {
		window.uploadCallBack = this.uploadCallBack;
	},
	methods: {
		validate() {
			const {selectedTag,feedback,contact} = this;
			
			if(!feedback || !contact){
				Toast({
					message: '请将信息填写完整',
					duration: 1000,
				});
				return false;
			}
			if(!selectedTag){
				Toast({
					message: '请选择一个标签',
					duration: 1000,
				});
				return false;
			}
			return true;
		},

		async init() {
			const res = await apiUtil.post(apiConst.getFeedbackTags);
			if (res.success) {
				const { tag } = res;
				this.tagList = tag.map(ele => {
					ele.name = ele.title;
					ele.isRound = true;
					return ele;
				});
			}
		},

		onTagClick(id) {
			this.selectedTag = id;
		},

		onRemoveClick(index) {
			this.img_path.splice(index, 1);
			this.img_fullPath.splice(index, 1);
		},
		uploadImg() {
			window.HostApp.takePhoto('uploadCallBack')

		},
		uploadCallBack(cb) {
			this.img_path.push(cb);
			this.img_fullPath.push(cb);
		},
		async onImgRead(file) {
			const res = await apiUtil.form(apiConst.submitImg, {
				cover: file.file,
				type: 1
			});
			if (res.success) {
				const { file_path, url } = res;
				this.img_path.push(file_path);
				this.img_fullPath.push(url);
			}
		},

		async onSubmitClick() {
			if (!this.validate()) {
				return;
			}
			const user = getUser();
			const res = await apiUtil.post(apiConst.submitFeedback, {
				tag_id: this.selectedTag,
				img_path: this.img_path,
				content: replaceEmoji(this.feedback),
				contact: replaceEmoji(this.contact),
				uid: user.uid
			});
			if (res.success) {
				Toast({
					message: '提交成功，感谢您的反馈',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
.feedback-view {
	.title {
		padding-left: 30px;
		height: 50px;
		line-height: 50px;
		background-color: #F8F8F8;
	}

	.tag-wrap {
		padding: 14px 0 0 30px;

		.tag-item-comp {
			margin-right: 42px;
			margin-bottom: 14px;
		}
	}

	.feedback-wrap {
		padding: 39px 0 80px 0;

		.img-wrap {
			margin-bottom: 20px;

			.img-item {
				display: inline-block;
				position: relative;

				.upload-img {
					margin-left: 62px;
					width: 148px;
					height: 148px;
				}

				.remove-icon {
					position: absolute;
					right: -13px;
					top: -13px;
					width: 26px;
					height: 26px;
					background-color: #ff0000;
					color: #fff;
					border-radius: 50%;
					text-align: center;
					line-height: 26px;
				}
			}
		}

		.van-uploader {
			.van-uploader__upload {
				margin-left: 62px;
				width: 148px;
				height: 148px;
				border: 1PX solid #9c9c9c;
			}
		}

		.van-field {
			height: 150px;
		}
	}
}
</style>
